const values = [
  {
    icon: "fa-handshake-angle",
    title: "Zuverlässig",
    text: "Absprachen klar festhalten und nachvollziehbar kommunizieren.",
  },
  {
    icon: "fa-sliders",
    title: "Flexibel",
    text: "Lösungen für private, gewerbliche und wiederkehrende Anfragen.",
  },
  {
    icon: "fa-eye",
    title: "Transparent",
    text: "Eine Offerte auf Basis der Informationen, die wirklich relevant sind.",
  },
  {
    icon: "fa-user",
    title: "Persönlich",
    text: "Direkter Kontakt statt anonymer Warteschleife.",
  },
];

export default values;